import { useTranslation } from 'react-i18next';

import ArrowRightShape from '@/components/common/svg/shapes/ArrowRightShape.tsx';
import {
  menuItemStyle,
  personalBlockContainer,
  afterStyle,
  iconWrapperStyle,
  menuTextStyle
} from '@/components/ProfileData/Blocks/styles.ts';
import AlcoholShape from '@/components/common/svg/shapes/AlcoholShape.tsx';
import SmokingShape from '@/components/common/svg/shapes/SmokingShape.tsx';
import { useProfileStore } from '@/store/useProfileStore.ts';
import { getSmokingOptions } from '@/components/Popup/EditProfile/EditSmokingStatusPopup.tsx';
import { getAlcoholPreferences } from '@/components/Popup/EditProfile/EditAlcoholPreferencePopup.tsx';

interface LifestyleBlockProps {
  onOpenAlcohol: () => void;
  onOpenSmoking: () => void;
}

export const LifestyleBlock = ({
  onOpenAlcohol,
  onOpenSmoking
}: LifestyleBlockProps) => {
  const { t } = useTranslation();
  const { aboutMe } = useProfileStore();
  const smokingOptions = getSmokingOptions(t);
  const alcoholPreferences = getAlcoholPreferences(t);

  const menuItems = [
    {
      shape: <AlcoholShape width={20} height={20} fillColor="#1A1A1A" />,
      onClick: onOpenAlcohol,
      labelKey: 'alcohol_title',
      after: aboutMe?.profile.alcohol_preference
        ? alcoholPreferences[aboutMe?.profile.alcohol_preference]
        : ''
    },
    {
      shape: <SmokingShape width={20} height={20} fillColor="#1A1A1A" />,
      onClick: onOpenSmoking,
      labelKey: 'smoking_title',
      after: aboutMe?.profile.smoking_status
        ? smokingOptions[aboutMe?.profile.smoking_status]
        : ''
    }
  ];

  return (
    <div style={personalBlockContainer}>
      {menuItems.map(({ shape, onClick, labelKey, after }) => (
        <div key={labelKey} style={menuItemStyle} onClick={onClick}>
          <div style={iconWrapperStyle}>{shape}</div>
          <div style={{ flexGrow: 1, textAlign: 'left' }}>
            <span style={menuTextStyle}>{t(labelKey)}</span>
            {after && <div style={afterStyle}>{after || t('add')}</div>}
          </div>
          <ArrowRightShape width={14} height={14} fillColor="#C8C8CB" />
        </div>
      ))}
    </div>
  );
};
